import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const roomConfig = {
  createRoom: {
    key: "createRoom",
    url: "/api/v1/rooms",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getRooms", "getRoomLimits"],
      onSuccessMessage: "Room created successfully",
      onErrorMessage: "Failed to create room",
    },
  },

  createMultipleRooms: {
    key: "createMultipleRooms",
    url: "/api/v1/rooms/batch",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getRooms", "getRoomLimits"],
      onSuccessMessage: "Rooms created successfully",
      onErrorMessage: "Failed to create rooms",
    },
  },

  getRooms: {
    key: "getRooms",
    url: "/api/v1/rooms",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getRoomLimits: {
    key: "getRoomLimits",
    url: "/api/v1/rooms/limits",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getRoomById: {
    key: "getRoomById",
    url: (data) => `/api/v1/rooms/${data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  updateRoom: {
    key: "updateRoom",
    url: (data) => `/api/v1/rooms/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getRooms", "getRoomById"],
      onSuccessMessage: "Room updated successfully",
      onErrorMessage: "Failed to update room",
    },
  },

  deleteRoom: {
    key: "deleteRoom",
    url: (data) => `/api/v1/rooms/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getRooms", "getDeletedRooms", "getRoomLimits"],
      onSuccessMessage: "Room deleted successfully",
      onErrorMessage: "Failed to delete room",
    },
  },

  getDeletedRooms: {
    key: "getDeletedRooms",
    url: "/api/v1/rooms/deleted",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  restoreRoom: {
    key: "restoreRoom",
    url: (data) => `/api/v1/rooms/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getRooms", "getDeletedRooms", "getRoomLimits"],
      onSuccessMessage: "Room restored successfully",
      onErrorMessage: "Failed to restore room",
    },
  },

  restoreRoomsByRoomType: {
    key: "restoreRoomsByRoomType",
    url: (data) => `/api/v1/rooms/restore-by-room-type/${data.roomTypeId}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getRooms", "getDeletedRooms", "getRoomLimits"],
      onSuccessMessage: "Rooms restored successfully",
      onErrorMessage: "Failed to restore rooms",
    },
  },
};
